import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemDialog from "../../../components/UIToolkit/Popups/Dialog";

type Props = {
	open: boolean;
	isSaving: boolean;
	onConfirm: () => void;
	onClose: () => void;
};

/**
 * Confirms saving a design over a saved printout: it becomes the version everyone in the department prints, and the
 * earlier ones stay in the history. It names no version number: the server numbers it on save, and a colleague may
 * save first. A new printout's Save asks for its name instead, which is its confirmation.
 */
export const CustomPrintoutSaveDialog: FC<Props> = ({ open, isSaving, onConfirm, onClose }) => {
	const { t } = useTranslation();
	return (
		<SystemDialog
			open={open}
			onClose={onClose}
			title={t("printout.custom.ai.save.confirm.title")}
			body={t("printout.custom.ai.save.confirm.body")}
			confirm={t("printout.custom.ai.save.confirm.button")}
			cancel={t("cancel")}
			onConfirm={onConfirm}
			confirmLoading={isSaving}
			confirmDisabled={isSaving}
			dataTestId="custom-printout-save-dialog"
			confirmDataTestId="custom-printout-save-confirm"
			cancelDataTestId="custom-printout-save-cancel"
		/>
	);
};
